import React from 'react';
import { ArrowRight, CheckCircle2, Plane, ShieldCheck } from 'lucide-react';
import { Button } from './ui/button';
import { heroData } from '../data/mock';

const Hero = () => {
  const scrollToContact = () => {
    document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative pt-32 pb-20 overflow-hidden bg-gradient-to-b from-gray-50 to-white">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 1px 1px, rgb(75, 85, 99) 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            {/* Trust Badge */}
            <div className="inline-flex items-center space-x-2 bg-white rounded-full px-4 py-2 shadow-md border border-gray-200">
              <ShieldCheck className="w-5 h-5 text-gray-700" />
              <span className="text-sm font-semibold text-gray-700">
                45 Years of Trusted Service
              </span>
            </div>

            {/* Main Heading */}
            <div className="space-y-4">
              <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
                {heroData.title}
              </h1>
              <p className="text-xl text-gray-600 font-medium">
                {heroData.subtitle}
              </p>
            </div>

            {/* Description */}
            <p className="text-lg text-gray-600 leading-relaxed">
              {heroData.description}
            </p>

            {/* Key Features */}
            <div className="grid sm:grid-cols-2 gap-4">
              <div className="flex items-start space-x-3">
                <CheckCircle2 className="w-6 h-6 text-gray-700 flex-shrink-0 mt-1" />
                <div>
                  <p className="font-semibold text-gray-900">100% Authentic</p>
                  <p className="text-sm text-gray-600">Verified generic medications</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <Plane className="w-6 h-6 text-gray-700 flex-shrink-0 mt-1" />
                <div>
                  <p className="font-semibold text-gray-900">Express Delivery</p>
                  <p className="text-sm text-gray-600">30+ countries worldwide</p>
                </div>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button
                onClick={scrollToContact}
                className="bg-gray-800 hover:bg-gray-900 text-white px-8 py-6 text-lg rounded-lg font-semibold transition-all duration-200 shadow-lg hover:shadow-xl hover:scale-105 flex items-center justify-center space-x-2"
              >
                <span>{heroData.ctaText}</span>
                <ArrowRight className="w-5 h-5" />
              </Button>
              <Button
                onClick={() => document.querySelector('#products')?.scrollIntoView({ behavior: 'smooth' })}
                variant="outline"
                className="border-2 border-gray-800 text-gray-800 hover:bg-gray-50 px-8 py-6 text-lg rounded-lg font-semibold transition-all duration-200"
              >
                View Products
              </Button>
            </div>

            {/* Stats */}
            <div className="flex flex-wrap gap-8 pt-8 border-t border-gray-200">
              <div>
                <p className="text-3xl font-bold text-gray-800">5000+</p>
                <p className="text-sm text-gray-600">Products Available</p>
              </div>
              <div>
                <p className="text-3xl font-bold text-gray-800">30+</p>
                <p className="text-sm text-gray-600">Countries Served</p>
              </div>
              <div>
                <p className="text-3xl font-bold text-gray-800">60%</p>
                <p className="text-sm text-gray-600">Average Savings</p>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src={heroData.image}
                alt="Professional Pharmacist"
                className="w-full h-[600px] object-cover"
              />
              {/* Overlay Badge */}
              <div className="absolute bottom-8 left-8 right-8 bg-white/95 backdrop-blur-sm rounded-xl p-6 shadow-xl">
                <p className="text-2xl font-bold text-gray-800 mb-2">Save up to 60%</p>
                <p className="text-gray-700">on all your prescription medications</p>
              </div>
            </div>

            {/* Floating Elements */}
            <div className="absolute -top-4 -right-4 bg-gray-800 text-white rounded-full w-24 h-24 flex items-center justify-center shadow-xl">
              <div className="text-center">
                <p className="text-2xl font-bold">45</p>
                <p className="text-xs">Years</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
